module.exports = {"__schema":{"types":[{"kind":"UNION","name":"ContentMediaHome","possibleTypes":[{"name":"ItemsMedia"},{"name":"MoviesMedia"}]}]}}


//////////////////
// WEBPACK FOOTER
// ./src/fragmentTypes.json
// module id = 693
// module chunks = 0